import { useUserRoles, useLoggedInUserPermissions } from '@anytag/auth';
import { MenuTitle, MenuType } from '@anytag/router';
import { loadingMenuItems, getAllowMenuItemsFromPermissions } from '../utils';

export const useMenuConfigs = () => {
  const { isAdvertiser, isAdminStaff } = useUserRoles();
  const { permissions, permissionLoading } = useLoggedInUserPermissions();

  let menuItems: MenuType[] = [];

  if (permissionLoading) {
    menuItems = loadingMenuItems;
  } else {
    menuItems = getAllowMenuItemsFromPermissions({
      isAdvertiser,
      isAdminStaff,
      permissions,
      hideOptions: [
        ...(!isAdvertiser ? [MenuTitle.Settings] : [MenuTitle.Influencers, MenuTitle.Posts]),
        ...(!isAdminStaff ? [MenuTitle.AutoManaged, MenuTitle.TikTokCampaigns] : [])
      ]
    });
  }

  return { menuItems, permissionLoading };
};
